import {mapMutations} from 'vuex';
export default {
    methods: {
        ...mapMutations('comments', {
            setCommentsCustomerId: 'setCustomerId',
            setCommentsSiteId: 'setSiteId',
            setCommentsParams: 'setParams',
        }),
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/UsesComments.js